export const FILTERS_TIMING_FETCH_START_KEY =
  "logged-in-category-page-filter-sections-fetch-start";
export const FILTERS_TIMING_FETCH_END_KEY =
  "logged-in-category-page-filter-sections-fetch-end";
export const LAYOUT_ELEMENTS_TIMING_FETCH_START_KEY =
  "logged-in-category-page-layout-elements-fetch-start";
export const LAYOUT_ELEMENTS_TIMING_FETCH_END_KEY =
  "logged-in-category-page-layout-elements-fetch-end";

export enum PageLoadTimingSectionName {
  FILTERS = "FILTERS",
  LAYOUT_ELEMENTS = "LAYOUT_ELEMENTS",
}

// 1 row of product tiles
export const NUM_FIRST_ROWS_IN_FILTERABLE_PAGINATED_SECTION = 1;
